import * as Vendors from './vendor/IabVendor.selectors';

import { IabGvl } from './Iab.schema';
import get from 'lodash/get';
import { getStore as getDB } from '../DB.store';

const emptyObject = {};
const emptyArray = [];

export const vendors = Vendors;

export const getVendorListById = (state, id) => get(getDB(state), [IabGvl.key, id]) || emptyObject;
export const getTcfV2Vendors = (state, vendorIds) => {
    return (vendorIds || []).reduce((vendors, id) => {
        const vendor = Vendors.getEntityById(state, id);
        if (vendor) {
            vendors[id] = vendor;
        }
        return vendors;
    }, {});
};

export const getVendorListVersion = state => {
    const gvlStore = get(getDB(state), [IabGvl.key], emptyObject);
    const gvlKeys = Object.keys(gvlStore)
        .map(key => parseInt(key, 10))
        .sort((a, b) => b - a);
    const gvlVersion = gvlKeys.length ? gvlKeys[0] : 0;
    return gvlVersion;
};
/**
 * @return {number} The GVL specification version from the latest vendor list, or 0 if not loaded.
 */
export const getGvlSpecificationVersion = state => {
    const gvlStore = get(getDB(state), [IabGvl.key], emptyObject);
    const gvl = Object.values(gvlStore)[0];
    return gvl ? gvl.gvlSpecificationVersion : 0;
};

export const getLastUpdatedById = (state, id) => {
    const lastUpdated = get(getVendorListById(state, id), 'lastUpdated', null);
    return lastUpdated ? new Date(lastUpdated) : null;
};

/**
 * Selector to get the list of vendors from the latest vendor list version.
 *
 * @param {Object} state - The Redux state.
 * @param {number} [id] - Optional vendor list version ID. If not provided, uses the latest version.
 * @return {number[]}
 */
export const getVendorListVendors = (state, id = getVendorListVersion(state)) => {
    const vendorList = id && getVendorListById(state, id);
    return vendorList?.vendors || emptyArray;
};
